export const TITLES_LIST_REQUEST = 'TITLES_LIST_REQUEST';
export const TITLES_LIST_SUCCESS = 'TITLES_LIST_SUCCESS';
export const TITLES_LIST_FAILURE = 'TITLES_LIST_FAILURE';

export function success(payload) {
  return dispatch => dispatch({ type: TITLES_LIST_SUCCESS, payload });
}

export function failure(payload) {
  return dispatch => dispatch({ type: TITLES_LIST_FAILURE, payload });
}

export default function list() {
  return dispatch => dispatch({ type: TITLES_LIST_REQUEST });
}
